import { getEnvironment } from './environment.constants'
import { EnvType } from '@mediacoach/ui'

export const environment = getEnvironment(EnvType.Dv)
